import styles from "./toggelSwictherCompare.module.scss";

export default function ToggleSwitchCompare({
  isChecked,
  setIsChecked,
  firstVal = "Monthly",
  secondVal = "Annually",
  pricingPage = false,
}) {
  return (
    <div className={styles.toggleSwitchContainer}>
      <div className={styles.toggleSwitch}>
        <input
          type="checkbox"
          id="toggle"
          checked={isChecked}
          onChange={(e) => setIsChecked(e.target.checked)}
          className={styles.toggleInput}
        />
        <label htmlFor="toggle" className={styles.toggleLabel}>
          <span className={styles.toggleTrack}>
            <span className={styles.toggleThumb}></span>
          </span>
        </label>
      </div>

      <span className={styles.periodText}>{secondVal}</span>

      {pricingPage && (
        <div className={styles.saveBadge}>
          <span>Save 40%</span>
        </div>
      )}
    </div>
  );
}
